
import {
  Box, SimpleGrid, useColorModeValue
} from "@chakra-ui/react";
import FormProduto from "./components/Form";
import OrderProductTable from "./components/Table";
import useProductOrder from "./hooks/useProductOrder";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";


export default function ProductOrderSceen() {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const {
    produtos,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    nome,
    changeNome,
    error,
    save,
    showDelete,
    showDeleteModal,
    cancelRef,
    closeDelete,
    deletar,
    changeItem,
    deleteRow,
    addRow,
    itens,
    errorMsg,
    errorTitle,
    closeError,
    condicaoPagamentos

  } = useProductOrder();

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>

      <ConditionalRenderer
        conditions={[
          {
            condition: show,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal(false)}
                title={accountSelected !== null ? "Editar Item" : "Novo Item"}
              >
                <FormProduto
                  accountSelected={accountSelected}
                  brandStars={brandStars}
                  error={error}
                  loading={loading}
                  nome={nome}
                  changeNome={changeNome}
                  save={save}
                  show={show}
                  showModal={showModal}
                  textColor={textColor}
                  changeItem={changeItem}
                  deleteRow={deleteRow}
                  addRow={addRow}
                  borderColor={borderColor}
                  itens={itens}
                  errorMsg={errorMsg}
                  errorTitle={errorTitle}
                  cancelRef={cancelRef}
                  closeError={closeError}
                  condicaoPagamentos={condicaoPagamentos}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <OrderProductTable
              add={add}
              edit={edit}
              list={produtos}
              deletar={showDeleteModal}
              showDelete={showDelete}
              cancelRef={cancelRef}
              closeDelete={closeDelete}
              remove={deletar}
            />
          </SimpleGrid>
        )}
      />
    </Box>
  );
}
